// extracted by mini-css-extract-plugin
export default {"breadcrumbItem":"HeaderBreadcrumbs_breadcrumbItem__DHcEB","disabled":"HeaderBreadcrumbs_disabled__R6qg0"};